import { render } from "./AcademicCoursesPage.vue?vue&type=template&id=4a0e591c&scoped=true"
import script from "./AcademicCoursesPage.vue?vue&type=script&lang=js"
export * from "./AcademicCoursesPage.vue?vue&type=script&lang=js"

import "./AcademicCoursesPage.vue?vue&type=style&index=0&id=4a0e591c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0e591c"]])

export default __exports__